import {ReactNode, useState} from 'react';
import {ToastVisibilityContext} from './ToastVisibilityContext';

interface CustomToasterProviderProps {
    children: ReactNode;
}

/** Контекст видимости тостера. ToasterProvider — один, в AuthWrapper. */
export const CustomToasterProvider: React.FC<CustomToasterProviderProps> = ({children}) => {
    const [isToasterVisible, setIsToasterVisible] = useState(false);
    const [currentToastName, setCurrentToastName] = useState<string | null>(null);
    const [toasterInstanceKey, setToasterInstanceKey] = useState(0);

    return (
        <ToastVisibilityContext.Provider
            value={{
                isToasterVisible,
                setIsToasterVisible,
                currentToastName,
                setCurrentToastName,
                toasterInstanceKey,
                bumpToasterInstanceKey: () => setToasterInstanceKey((prev) => prev + 1)
            }}
        >
            {children}
        </ToastVisibilityContext.Provider>
    );
};
